import { useAlertPopupsContext } from 'context/AlertPopups'
import { CLOUD_OVERLOAD_PNG } from 'consts/images'
import { goToProfileSubscriptionsPage } from 'utils'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { useCallback } from 'react'
import { Button } from 'common-components'
import * as Styled from './styled'

const FullStoragePopup = () => {
  const {
    alertPopupsData: {
      fullStoragePopup: { isOpen = false, onClose }
    },
    resetAlertPopupsData
  } = useAlertPopupsContext()

  const handleClose = useCallback(() => {
    onClose && onClose()
    resetAlertPopupsData()
  }, [onClose, resetAlertPopupsData])

  const onButtonClick = () => {
    handleClose()
    goToProfileSubscriptionsPage()
  }

  return (
    <Styled.FullStoragePopup isOpen={isOpen} onClose={handleClose}>
      <Styled.FullStorageWarningContainer>
        <Styled.FullStorageImage
          src={CLOUD_OVERLOAD_PNG}
          alt="cloud overload"
        />
        <Styled.WarningDescription
          type="h2"
          lineHeight="20px"
          color="secondarySemiDark"
          align="center"
        >
          {translate(T.FULL_STORAGE_WARNING)}
        </Styled.WarningDescription>
        <Button type="primary" onClick={onButtonClick}>
          {translate(T.UPGRADE)}
        </Button>
      </Styled.FullStorageWarningContainer>
    </Styled.FullStoragePopup>
  )
}

export default FullStoragePopup
